import { CoreTelemetryClient } from '@pp/telemetry';

import { Version } from '../utils/Version';

export const Telemetry = new CoreTelemetryClient({
  appVersion: Version.displayVersion,
  language: '',
});
